/**
 * Cart drawer "Complete the look" cards. The arrows scroll the cards, and one tap adds the chosen option with
 * Shopify's cart/add.js, then the theme refreshes the drawer and header in place.
 */
(() => {
  if (window.wjCartAddonsInitialized) return;
  window.wjCartAddonsInitialized = true;
  let adding = false;
  const root = () => ((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/').replace(/\/?$/, '/');

  document.addEventListener('change', (evt) => {
    const select = evt.target;
    if (!select || !select.matches || !select.matches('.wj-addon__select')) return;
    const row = select.closest('.wj-addon');
    const option = select.selectedOptions[0];
    if (!row || !option) return;
    const button = row.querySelector('[data-wj-addon-add]');
    if (button) button.dataset.variantId = option.value;
    const price = row.querySelector('.wj-addon__price');
    if (price && option.dataset.price) price.textContent = option.dataset.price;
    const img = row.querySelector('.wj-addon__img img');
    if (img && option.dataset.img) img.src = option.dataset.img;
  });

  document.addEventListener('click', (evt) => {
    const arrow = evt.target && evt.target.closest && evt.target.closest('[data-wj-addons-scroll]');
    if (!arrow) return;
    evt.preventDefault();
    const wrap = arrow.closest('[data-wj-addons]');
    const track = wrap && wrap.querySelector('[data-wj-addons-track]');
    const card = track && track.querySelector('.wj-addon');
    if (!card) return;
    const step = card.getBoundingClientRect().width + 12;
    track.scrollBy({ left: step * Number(arrow.dataset.wjAddonsScroll || 1), behavior: 'smooth' });
  });

  document.addEventListener('click', async (evt) => {
    const button = evt.target && evt.target.closest && evt.target.closest('[data-wj-addon-add]');
    if (!button) return;
    evt.preventDefault();
    if (adding) return;
    const id = Number(button.dataset.variantId);
    if (!id) return;
    const wrap = button.closest('[data-wj-addons]');
    const message = wrap && wrap.querySelector('.wj-addons__error');
    const label = button.textContent;
    adding = true;
    button.disabled = true;
    button.textContent = button.dataset.addingLabel || 'Adding';
    if (message) { message.hidden = true; message.textContent = ''; }

    try {
      const response = await fetch(root() + 'cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id, quantity: 1 }] })
      });
      const payload = await response.json().catch(() => ({}));
      if (!response.ok) throw new Error(payload.description || payload.message || 'Unable to add this item.');
      document.dispatchEvent(new CustomEvent('on:cart:change', { bubbles: true, cancelable: false }));
    } catch (error) {
      button.disabled = false;
      button.textContent = label;
      if (message) {
        message.textContent = (error && error.message) || 'Please try again.';
        message.hidden = false;
      }
    } finally {
      adding = false;
    }
  });
})();
